<template>
  <div class="bg-light">
    <Banner/>
      <b-container class="mt-5 py-4">
        <b-row class="flex-column-reverse flex-lg-row">
          <b-col md="11" lg="7">
            <stack00 />
            <b-row>
              <b-col cols="11" offset="1" style="text-align: center" class="d-xs-block d-sm-none">
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
              </b-col>
              <b-col cols="11" offset="1" style="text-align: center" class="d-none d-sm-block d-md-none d-lg-block d-xl-none">
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x"/></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x"/></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x"/></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x"/></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x"/></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x"/></span>
              </b-col>
              <b-col cols="11" offset="1" style="text-align: center" class="d-none d-md-block d-lg-none d-xl-block">
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
                <span class="px-4 text-danger"><font-awesome-icon :icon="iconArrowDown" size="2x" /></span>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="11" offset-md="1" lg="4" style="color: #2e145e; text-align: center">
            <h1 style="font-size: 48px; font-weight: 400" class="mb-2">
              <img src="/images/Logo-3.png" class="pb-1">
              Solution Stack
            </h1>
          </b-col>
        </b-row>
        <stack01 />
        <b-row>
          <b-col md="11" lg="6" offset="1" class="text-danger" style="text-align: center">
            <font-awesome-icon :icon="iconArrowDown" size="3x" />
          </b-col>
        </b-row>
        <stack02 />
        <b-row>
          <b-col md="11" lg="6"  offset="1" class="text-danger" style="text-align: center">
            <font-awesome-icon :icon="iconArrowDown" size="3x" />
          </b-col>
        </b-row>
        <stack03 />
        <b-row>
          <b-col md="11" lg="6"  offset="1" class="text-danger" style="text-align: center">
            <font-awesome-icon :icon="iconArrowDown" size="3x" />
          </b-col>
        </b-row>
        <stack04 />
        <b-row>
          <b-col md="11" lg="6"  offset="1" class="text-danger" style="text-align: center">
            <font-awesome-icon :icon="iconArrowDown" size="3x" />
          </b-col>
        </b-row>
        <stack05 />
        <b-row>
          <b-col md="11" lg="6" offset="1" class="text-danger" style="text-align: center">
            <font-awesome-icon :icon="iconArrowDown" size="3x" />
          </b-col>
        </b-row>
        <stack06 />
      </b-container>
    <footerNav />
  </div>
</template>

<script>
// @ is an alias to /src
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowDown, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import Banner from '@/components/Banner.vue';
import stack00 from '@/components/stack00.vue';
import stack01 from '@/components/stack01.vue';
import stack02 from '@/components/stack02.vue';
import stack03 from '@/components/stack03.vue';
import stack04 from '@/components/stack04.vue';
import stack05 from '@/components/stack05.vue';
import stack06 from '@/components/stack06.vue';
import footerNav from '@/components/footer.vue';

export default {
  name: 'solidLDP',
  components: {
    Banner,
    stack00,
    stack01,
    stack02,
    stack03,
    stack04,
    stack05,
    stack06,
    footerNav,
    FontAwesomeIcon,
  },
  data () {
    return {
      iconArrowDown: faArrowDown,
      iconCaretDown: faCaretDown
      }
  },
};
</script>
